import { Stack, Typography } from "@mui/material";
import { t } from "i18next";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";

const diplayRows = [
  "date_and_month",
  "worker_upcomming_job_detail",
  "worker_upcomming_job_price",
];

const WorkerTodaysJobs = ({ allJobs, isLoading }) => {
  return (
    <Template
      primaryHeading={t("todaysJobActivity")}
      secondaryHeading={t("viewTodaysJob")}
    >
      {allJobs?.length == 0 && isLoading?.states === false ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography variant="h5" fontWeight={600}>
            {t("noTodaysJobsFound")}
          </Typography>
        </Stack>
      ) : (
        <DashboardTable
          showHeader={false}
          tableData={allJobs}
          diplayRows={diplayRows}
        />
      )}
    </Template>
  );
};

export default WorkerTodaysJobs;
